import PropTypes from 'prop-types'
import React, { Component } from 'react'

import OverviewViewContainer from 'Overview/Overview/containers/Common'

import IpadNavigation from 'Navigation/IpadNavigation'
import Navigation from 'Navigation/Navigation'
import OverviewList from 'Overview/Overview/components/List/List'

import Info from 'Overview/RevenueAndCosts/components/Info/Info'
import Dates from 'Overview/Overview/components/Dates'

class LeftSideView extends Component {
  static propTypes = {
    t: PropTypes.func
  }
  render () {
    const {t} = this.props
    return (
      <Navigation title={t('navbar', 'title').s} className='overview-view' home>
        <OverviewList {...this.props} className='overview-list--tablet' />
      </Navigation>
    )
  }
}

class OverviewView extends Component {
  static propTypes = {
    settings: PropTypes.object,
    results: PropTypes.object,
    tViews: PropTypes.func,
    loadOverviewData: PropTypes.func
  }

  render () {
    const {settings, loadOverviewData, tViews, results: {monthlyResults}} = this.props
    return (
      <IpadNavigation notBack {...this.props} title={tViews('RevenueAndCosts', 'title').s}>
        <LeftSideView {...this.props} />
        <div className='overview-rev-costs'>
          <Dates settings={settings} onSaveClick={loadOverviewData} />
          <Info data={monthlyResults} t={tViews('RevenueAndCosts')} type='result' />
        </div>
      </IpadNavigation>
    )
  }
}

export default OverviewViewContainer(OverviewView)
